'use client';

import { useState } from 'react';
import WinItemAContent from './WinItemAContent';
import WinItemASuccess from './WinItemASuccess';

export default function WinItem({ isExchange, activeType, data = {}, winItemCallback }: any) {
    const [winType, setWinType] = useState('content');
    const [confirmData, setConfirmData] = useState({});
    const winItemCallback1 = (params: any, data?: any) => {
        if (params === 'confirm') {
            setWinType('success');
            setConfirmData(data || {});
        } else {
            winItemCallback && winItemCallback(params);
        }
    };
    const winItemCallback2 = () => {
        winItemCallback && winItemCallback('close');
    };

    return (
        <>
            {winType === 'content' && <WinItemAContent isExchange={isExchange} activeType={activeType} data={data} winItemCallback={winItemCallback1} />}
            {winType === 'success' && <WinItemASuccess activeType={activeType} data={confirmData} winItemCallback={winItemCallback2} />}
        </>
    );
}
